import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CalendlyFab from '../../components/CalendlyFab';

const KlassiCareHome = () => {
  return (
    <div className="bg-dark min-vh-100">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold mb-3 text-light">KlassiCare</h1>
          <p className="lead text-warning fw-bold">Exceptional Care Services</p>
        </div>

        <Row className="g-4 mb-5 justify-content-center">
          <Col xs={12} md={6} lg={3} className="text-center">
            <Link to="/klassicare/nanny" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/logo.png" 
                  alt="Nanny Services"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Nanny Services</h3>
              <p className="text-light-50">
                Professional and experienced nannies.
                Quality care for your children.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={3} className="text-center">
            <Link to="/klassicare/elderly" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/logo.png" 
                  alt="Elderly Care"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Elderly Care</h3>
              <p className="text-light-50">
                Compassionate care for the elderly.
                Support and assistance when needed.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={3} className="text-center">
            <Link to="/klassicare/special" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/logo.png" 
                  alt="Special Needs Care"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Special Needs Care</h3>
              <p className="text-light-50">
                Specialized care for unique needs.
                Professional and understanding support.
              </p>
            </Link>
          </Col>
          <Col xs={12} md={6} lg={3} className="text-center">
            <Link to="/contact" className="text-decoration-none">
              <div className="p-3">
                <img 
                  src="/logo.png" 
                  alt="Contact Us"
                  className="img-fluid rounded"
                  style={{ 
                    cursor: 'pointer',
                    width: '150px',
                    height: '150px',
                    objectFit: 'cover',
                    border: '3px solid #FFD700',
                    borderRadius: '15px'
                  }}
                />
              </div>
              <h3 className="mt-3 text-light fw-bold">Contact Us</h3>
              <p className="text-light-50">
                Ready to discuss your care needs?
                Get in touch with our team today.
              </p>
            </Link>
          </Col>
        </Row>

        <Row className="g-4 mb-5">
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Why Choose KlassiCare?</h2>
              <ul className="text-primary">
                <li className="mb-2">Thoroughly vetted and background-checked caregivers</li>
                <li className="mb-2">Flexible scheduling options to fit your family's needs</li>
                <li className="mb-2">Experienced professionals with childcare certifications</li>
                <li className="mb-2">Personalized matching process for your family</li>
                <li className="mb-2">Ongoing support and quality assurance</li>
              </ul>
            </div>
          </Col>
          <Col md={6}>
            <div className="bg-dark-subtle p-4 rounded shadow">
              <h2 className="text-light mb-4">Our Commitment</h2>
              <p className="text-primary mb-4">
                At KlassiCare, we understand that finding the right childcare solution is crucial for your family's well-being. We are committed to:
              </p>
              <ul className="text-primary">
                <li className="mb-2">Providing safe and nurturing care environments</li>
                <li className="mb-2">Matching families with qualified caregivers</li>
                <li className="mb-2">Supporting children's development and growth</li>
                <li className="mb-2">Ensuring peace of mind for parents</li>
              </ul>
            </div>
          </Col>
        </Row>

        <div className="video-container bg-dark p-4 rounded shadow-lg mb-5">
          <div className="ratio ratio-16x9" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <iframe
              src="https://www.youtube.com/embed/brSA9Ltsqe4?rel=0"
              title="KlassiCare Introduction"
              allowFullScreen
              className="rounded"
            ></iframe>
          </div>
        </div>

        <CalendlyFab />
      </Container>
    </div>
  );
};

export default KlassiCareHome; 